import {
  Communicator,
  createCommunicatorHook,
} from "../../Helpers/Communicator";

export const ticketCommunicator = new Communicator();

export const useTicketCommunicator = createCommunicatorHook(ticketCommunicator);
